import { buildEndPoint } from '@mairistem/tools';
import dayjs from 'dayjs';

import { formatFilters, formatSort } from '@/utils';
import baseUrl from './base';

export const postBordereauVersement = () => `${baseUrl}/bordereaux-versements`;

export const postDetailNumeraireBordereau = (id: number) =>
  `${baseUrl}/bordereaux-versements/${id}/numeraire-details`;

export const deleteBordereau = (id: number) => `${baseUrl}/bordereaux-versements/${id}`;

export const getBordereaux = (
  {
    page,
    perPage,
    sorts,
    filters,
    codeModeReglement,
    ...rest
  }: {
    page?: number;
    perPage?: number;
    sorts?: any[];
    filters?: any[];
    codeModeReglement?: string;
    [key: string]: any;
  } = {
    page: 1,
    perPage: 1000,
    sorts: [],
    filters: [],
  },
) =>
  buildEndPoint(`${baseUrl}/bordereaux-versements`, {
    page,
    perPage: 1000,
    sort: formatSort(sorts),
    ...formatFilters(filters),
    codeModeReglement,
    dateRemise: `since(${dayjs().year()}-01-01)`,
    ...rest,
  });
